import { isNil } from "@utils/assert";
import { getEnumValues } from "@utils/enum-utils";

export enum Disease {
	IDK = "IDK",
	PREFER_NOT_TO_SAY = "PREFER_NOT_TO_SAY",
	OTHER = "OTHER",
	SMA = "SMA",
	ALS = "ALS",
	BMD = "BMD",
	FSHD = "FSHD",
	LGMD = "LGMD",
	CMT = "CMT",
	OTHER_MUSCULAR_DYSTROPHY = "OTHER_MUSCULAR_DYSTROPHY",
	MYASTHENIA = "MYASTHENIA",
	NEUROPATHY = "NEUROPATHY",
	MYOPATHY = "MYOPATHY",
	METABOLIC_DISORDERS = "METABOLIC_DISORDERS",
	FRIEDREICH_ATAXIA = "FRIEDREICH_ATAXIA",
	MULTIPLE_SCLEROSIS = "MULTIPLE_SCLEROSIS",
}

export const diseases = getEnumValues(Disease);

export enum FunctionalStatus {
	Walker = "WALKER",
	Sitter = "SITTER",
}

export const functionalStatuses = getEnumValues(FunctionalStatus);

export const isUnspecifiedDisease = (disease?: Disease): boolean =>
	isNil(disease) || [Disease.IDK, Disease.PREFER_NOT_TO_SAY].includes(disease);
